<nb-alert *ngIf="true" class="info" [accent]="status" [style.justify-content]="alignment">
  <nb-icon class="icon" nbPrefix [status]="status" icon="info-outline" pack="eva"></nb-icon>
  <p>{{ text }}</p>
</nb-alert>
